export default __webpack_public_path__ + "static/trading-image-9ca0ceea14797b957f2ff2dcecb0b341.png";